//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"
import mixinComponent from '../mixins'

export default {
    props: ['name', 'index', 'displayLanguage'],
    mixins: [mixinComponent],
    data() {
        return {
            text_class: 'text-color-light',
            default_vote_down: false,
            slots: []
        }
    },
    computed: {
        has_adsense: function() {
            return this.$variables.enable_in_post_ads && 
                    this.$variables.adsense_publisher_id && 
                    this.slots.length != 0 &&
                    this.index % 2 == 0
        },
        slot_id: function() {
            return this.slots.length > 1? this.slots.shift() : this.slots[0]
        },
        list_number: function () {
            return this.has('counter', false)
        },
        has_title: function () {
            return this.has('title', false)
        },
        has_description: function () {
            return this.has('description')
        },
        block_type: function () {
            return this.has('block_type', false)
        },
        bg_color: function () {
            return this.has('block_colors.hex', false)
        },
        block_class: function () {
            return this.has('block_text_class', this.text_class)
        },
        vote_down: function () {
            return this.has('vote_down', this.default_vote_down)
        },
        up_votes: function () {
            return this.has_block('counts.up')
        },
        down_votes: function () {
            return this.has_block('counts.down')
        }
    },
    created() {
        this.slots = this.$variables.ads_slot_ids
    },
    methods: {
        has_voted: function () {
            return this.has_block('has_voted', false)
        },
        upvoted: function () {
            return this.has_block('has_upvoted', false)
        },
        downvoted: function () {
            return this.has_block('has_downvoted', false)
        },
        vote_block: function (e) {
            if (this.has_voted()) return

            let curTarget = e.currentTarget
            let $this = curTarget.dataset
            const url = this.$variables.ranking_url
            var action = {}
            action['action'] = $this.action
            action['index'] = this.has_block('index')
            action['post_id'] = this.post_id()
            action['url'] = url

            if (action['action'] == '' || !url) {
                Quizier.sweetError(this.$t('i18n.somethingWentWrong'))
                return false
            }

            axios.post(url, action).then(res => {
                if (res.data.reload) {
                    location.reload()
                }
                if (res.data.success) {
                    this._updateMe('has_voted', true)
                    this._updateMe('counts', res.data.action.counts)
                    // this.sortUpdate()
                }
            }).catch(err => {
                console.log('err from modcont', err)
                Quizier.sweetError(err.response.data.message)
                return false
            })
        },
    }
}
